$(document).on('change', '#schedule', function () {
  if ($(this).prop('checked') == true) {
    get_time_slots();
    $('.restaurant_schedule_time').html(' ');
    $('.schedule-details-section').removeClass('d-none');
  }
  else if($(this).prop('checked') == false){
    $('.restaurant_schedule_time').html(' ');
    $('.schedule-details-section').addClass('d-none');
  }
});
$(document).on('change', '#asap', function () {
  if ($(this).prop('checked') == true) {
    $('.restaurant_schedule_time').html(' ');
    $('.schedule-details-section').addClass('d-none');
  }
  else if($(this).prop('checked') == false){
    $('.restaurant_schedule_time').html(' ');
    $('.schedule-details-section').removeClass('d-none');
  }
});

$(document).on('change', '.datepicker', function () {
  var schedule_date = $(this).val();
  get_time_slots_for_schedule(schedule_date);
});
window.get_time_slots = function () {
  $.ajax({
    url: '/orders/find_opening_and_closing_time',
    type: "post",
    data: {
    },
    dataType: "script"
  });
}
window.get_time_slots_for_schedule = function (schedule_date) {
  $.ajax({
    url: '/orders/find_opening_and_closing_time',
    type: "post",
    data: {
      schedule_date: schedule_date
    },
    dataType: "script"
  });
}

window.appropriate_time = (time) => {
  var hour = parseInt(time.split(":")[0], 10);
  var split_time = time.split(":")[1];
  var minute = parseInt(split_time.split(" ")[0], 10);
  var am_pm = split_time.split(" ")[1];
  if (minute > 0 && minute <= 30) {
    minute = 30;
  } else if (minute > 30) {
    if (hour == 11) {
      if (am_pm == "PM") {
        am_pm = "AM";
      } else {
        am_pm = "PM";
      }
    }
    if (hour == 12) {
      hour = 1;
    } else {
      hour += 1;
    }
    minute = 0;
  }
  return final_time = hour + ':' + ("00" + minute).substr(-2) + ' ' + am_pm
}